// Imports
import 'lazysizes';
import reframe from 'reframe.js';
import htmx from "htmx.org";

import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';

// Project imports
import Appear from '@js/modules/Appear';
import AppearGrid from '@js/modules/AppearGrid';
import AppearList from '@js/modules/AppearList';
import BackButtons from '@js/modules/BackButtons';
import Carousel from '@js/modules/Carousel';
import ExternalLinks from '@js/modules/ExternalLinks';
import FloorplansMap from '@js/modules/FloorplansMap';
import Header from "@js/modules/Header";
import Navigation from '@js/modules/Navigation';
import Popup from '@js/modules/Popup';
import Slideover from '@js/modules/Slideover';
import Search from '@js/modules/Search';

class Page {
    constructor() {
    }
    init() {
        // Appear animations
        Appear.init();
        AppearGrid.init();
        AppearList.init();

        // External links
        ExternalLinks.build();

        setTimeout(() => {
            window.FORMS.modules.Forms.destroyForms();

            setTimeout(() => {
                window.FORMS.modules.Forms.init();
                window.FORMS.modules.Forms.refresh();
            }, 200);
        }, 200);

        /**
         * Header
         */
        Header.destroy();
        Header.init();

        /**
         * Back button
         */
        BackButtons.init();

        /**
         * Floor Plans
         */
        setTimeout(() => {
            FloorplansMap.init();
        }, 100);

        /**
         * Search
         */
        Search.init();

        /**
         * Carousels
         */
        Carousel.initAll();

        /**
         * Slideover
         */
        Slideover.init();

        /**
         * Reframe
         */
        reframe('.reframe');

        /**
         * Open external links in new tab
         */
        const extLinks = document.querySelectorAll('[data-external]');
        if (extLinks) {
            extLinks.forEach((item, i) => {
                item.addEventListener('click', (e) => {
                    let url = item.getAttribute('href');
                    window.open(url, '_blank').focus();
                });
            });
        }

        /**
         * Line hover
         */
        const lineHoverEls = document.querySelectorAll('.link-hover');
        lineHoverEls.forEach((el, i) => {
            el.addEventListener('mouseover', () => {
                el.classList.add('_hover');
            });

            el.addEventListener('mouseout', () => {
                el.classList.remove('_hover');
            });
        });

        /**
         * To top button
         */
        const toTopBtns = document.querySelectorAll('.to-top');
        toTopBtns.forEach(btn => {
           btn.addEventListener('click', (e) => {
               window.scrollTo({
                   top: 0,
                   left: 0,
                   behavior: 'auto',
               });
           });
        });

        /**
         * Date picker
         */
        let todayBtn = {
            content: 'Today',
            className: '',
            onClick: (dp) => {
                let date = new Date();
                dp.selectDate(date);
                dp.setViewDate(date);
            }
        };
        new AirDatepicker('#floorplan-movein-dp', {
            buttons: [todayBtn, 'clear'],
            locale: localeEn,
            minDate: new Date(),
            position: 'bottom right',
            isMobile: window.innerWidth < 768,
            onSelect: ({ date }) => {
                // Update hidden input
                let moveinInput = document.getElementById('movein-input');
                let selectedDate = date ? date.toISOString().split('T')[0] : '';
                moveinInput.value = selectedDate;
                moveinInput.dispatchEvent(new Event('input'));

                if (typeof htmx !== 'undefined') {
                    // Update Sprig component
                    htmx.trigger('#floorplan-search-component', 'refresh');
                }

                // Remove focus on date picker
                document.getElementById('floorplan-movein-dp').blur();
            }
        });
    }
}

export default new Page();
